<template>
  <div class="p-4">
    <h1 class="text-2xl font-mono mb-4 text-gray-800">Home Route</h1>
    <p class="text-gray-600">Welcome to the home route!</p>
    <p class="mt-4 text-sm text-gray-500">Use the control panel above to trigger requests.</p>
  </div>
</template>

<script setup lang="ts">
// No functions needed here - using controls from App.vue
</script>
